// Lingue supportate dalla landing: elenco e ordine arrivano dalla fonte unica.
import localesConfig from '@genome/i18n/src/i18n/locales.config.json';

export const LOCALES = localesConfig.languages;

export const RTL_LOCALES = localesConfig.rtl;

export const SITE_URL = 'https://jarvisinterviews.com';
// Default SEO/blog: x-default della fonte unica (l'app usa 'default', vedi I18nContext).
export const DEFAULT_LOCALE = localesConfig.xDefault;

export function isRtl(lang: string): boolean {
  return (RTL_LOCALES as readonly string[]).includes(lang);
}
